/**
 * v-auth
 * 按钮权限指令
 */
import type { Directive, DirectiveBinding } from "vue";

import { useUserStore } from "@/stores/user";
import { AccountType, useAccountStore } from "@/stores/account";

const auth: Directive = {
    mounted(el: HTMLElement, binding: DirectiveBinding) {
        const { value } = binding;
        const userStore = useUserStore();
        const accountStore = useAccountStore();
        // 主账号不做按钮角色权限判断
        if (accountStore.accountType !== AccountType.SUB_ACCOUNT) return;
        const permissions = userStore.userInfo.permissions || [];
        // 子账号按钮角色权限判断
        if (value instanceof Array && value.length) {
            const hasPermission = value.some(item => permissions.includes(item));
            if (!hasPermission) {
                el.remove();
            }
        } else {
            if (!permissions.includes(value)) {
                el.remove();
            }
        }
    }
};

export default auth;
